import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';
import styled from '../../styled';

const StyledHeadline = styled(Typography)`
  font-weight: 700;
  color: #0e1c2b;
  font-family: 'Merriweather', serif;
  letter-spacing: -0.02em;
  margin: 0;

  &.MuiTypography-h1 {
    font-size: ${(p) => p.theme.typography.h1.fontSize};
    line-height: 1.2;

    @media (max-width: 960px) {
      font-size: 2.5rem;
      line-height: 1.15;
    }

    @media (max-width: 600px) {
      font-size: 2rem;
      line-height: 1.15;
    }

    @media (max-width: 400px) {
      font-size: 1.875rem;
      line-height: 1.15;
    }
  }

  &.MuiTypography-h2 {
    font-size: ${(p) => p.theme.typography.h2.fontSize};
    line-height: 1.2;

    @media (max-width: 960px) {
      font-size: 2rem;
      line-height: 1.2;
    }

    @media (max-width: 600px) {
      font-size: 1.75rem;
      line-height: 1.2;
    }

    @media (max-width: 400px) {
      font-size: 1.625rem;
      line-height: 1.2;
    }
  }

  &.MuiTypography-h3 {
    font-size: ${(p) => p.theme.typography.h3.fontSize};
    line-height: 1.25;

    @media (max-width: 960px) {
      font-size: 1.75rem;
      line-height: 1.25;
    }

    @media (max-width: 600px) {
      font-size: 1.625rem;
      line-height: 1.25;
    }

    @media (max-width: 400px) {
      font-size: 1.5rem;
      line-height: 1.25;
    }
  }

  &.MuiTypography-h4 {
    font-size: ${(p) => p.theme.typography.h4.fontSize};
    line-height: 1.3;

    @media (max-width: 600px) {
      font-size: 1.4375rem;
      line-height: 1.3;
    }
  }

  &.MuiTypography-h5 {
    font-size: ${(p) => p.theme.typography.h5.fontSize};
    line-height: 1.35;

    @media (max-width: 600px) {
      font-size: 1.3125rem;
      line-height: 1.35;
    }
  }

  &.MuiTypography-h6 {
    font-size: ${(p) => p.theme.typography.h6.fontSize};
    line-height: 1.35;

    @media (max-width: 600px) {
      font-size: 1.1875rem;
      line-height: 1.35;
    }
  }
` as typeof Typography;

export const Headline = ({
  children,
  component = 'h2',
  variant,
  ...props
}: {
  children: React.ReactNode;
  component?: React.ElementType;
  variant?: TypographyProps['variant'];
  [key: string]: any;
}) => {
  // If variant is not provided, infer it from component
  const inferredVariant =
    variant ||
    (typeof component === 'string' && component.match(/^h[1-6]$/)
      ? (component as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6')
      : 'h2');

  return (
    <StyledHeadline component={component} variant={inferredVariant} {...props}>
      {children}
    </StyledHeadline>
  );
};
